module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@5.8.38@babel-runtime/core-js/object/get-prototype-of.js
// module id = 114
// module chunks = 0